import {
  BpkStack,
  BpkSpacing,
} from '@skyscanner-internal/backpack-web/bpk-component-layout';
import BpkLink from '@skyscanner-internal/backpack-web/bpk-component-link';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner-internal/backpack-web/bpk-component-text';

import { useTranslation } from '../../helpers/hooks/useTranslation';
import AppErrorBoundary from '../AppErrorBoundary';

const MonthViewPriceMessage = () => {
  const translate = useTranslation();
  return (
    <AppErrorBoundary location="month-view__price-msg">
      <BpkStack
        gap={BpkSpacing.MD}
        marginTop={BpkSpacing.Base}
        data-testid="footer-disclaimer"
      >
        <BpkText textStyle={TEXT_STYLES.footnote}>
          {translate('indicative_price_disclaimer')}{' '}
        </BpkText>
        <BpkLink
          href="https://help.skyscanner.net/hc/articles/201750142-How-do-I-find-the-cheapest-prices-across-a-month"
          target="_blank"
          rel="noopener noreferrer"
        >
          <BpkText textStyle={TEXT_STYLES.footnote}>
            {translate('learn_more_about_prices')}
          </BpkText>
        </BpkLink>
      </BpkStack>
    </AppErrorBoundary>
  );
};

export default MonthViewPriceMessage;
